import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router, RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { LoginComponent } from './login.component';
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatFormFieldModule,
		MatCardModule,
		MatInputModule,
		FormsModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatIconModule,
		RouterModule.forChild([
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'default/project/login'
			},
			{
				path: '**',
				component: LoginComponent,
				data: SaveStateData
			}
		])
	],
	declarations: [LoginComponent],
	exports: [LoginComponent]
})
export class LoginModule {}
